import script from "./HelpSupportModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpSupportModal.vue?vue&type=script&setup=true&lang=ts"

import "./HelpSupportModal.vue?vue&type=style&index=0&id=0192ba35&lang=scss&scoped=true"
import "./HelpSupportModal.vue?vue&type=style&index=1&id=0192ba35&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0192ba35"]])

export default __exports__